// extracted by mini-css-extract-plugin
export default {"container":"container___F2Qi3","title":"title___MwFzI","content":"content___T61s0"};